import { render, staticRenderFns } from "./AssetTelemetryDashboard.vue?vue&type=template&id=2204c834&scoped=true"
import script from "./AssetTelemetryDashboard.vue?vue&type=script&lang=js"
export * from "./AssetTelemetryDashboard.vue?vue&type=script&lang=js"
import style0 from "./AssetTelemetryDashboard.vue?vue&type=style&index=0&id=2204c834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2204c834",
  null
  
)

export default component.exports